import { render } from "./InitialHoldDetails.vue?vue&type=template&id=0946833a&scoped=true&ts=true&lang=pug"
import script from "./InitialHoldDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./InitialHoldDetails.vue?vue&type=script&setup=true&lang=ts"

import "./InitialHoldDetails.vue?vue&type=style&index=0&id=0946833a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0946833a"]])

export default __exports__